import { render, staticRenderFns } from "./ToggleAllergensButtonBlock.vue?vue&type=template&id=c1e6c404&scoped=true&"
import script from "./ToggleAllergensButtonBlock.vue?vue&type=script&lang=js&"
export * from "./ToggleAllergensButtonBlock.vue?vue&type=script&lang=js&"
import style0 from "./ToggleAllergensButtonBlock.vue?vue&type=style&index=0&id=c1e6c404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e6c404",
  null
  
)

export default component.exports